var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 16.65L12.25 9.5375C12.7375 8.625 13 7.6 13 6.5C13 2.9125 10.0875 0 6.5 0C2.9125 0 0 2.9125 0 6.5C0 10.0875 2.9125 13 6.5 13C7.6 13 8.625 12.725 9.5375 12.25L16.65 19.3625C17.0875 19.8 17.6375 20.0125 18.175 20.0125C18.6625 20.0125 19.125 19.8375 19.475 19.4875C20.225 18.7375 20.175 17.4625 19.35 16.65ZM1 6.5C1 3.4625 3.4625 1 6.5 1C9.5375 1 12 3.4625 12 6.5C12 9.5375 9.5375 12 6.5 12C3.4625 12 1 9.5375 1 6.5ZM18.775 18.775C18.55 19 18.2875 19.025 18.1125 19.0125C17.8375 18.9875 17.5625 18.8625 17.3625 18.65L10.4125 11.7C10.9 11.3375 11.3375 10.9 11.7 10.4125L18.65 17.3625C18.85 17.5625 18.9875 17.8375 19.0125 18.1125C19.0125 18.2875 18.9875 18.55 18.775 18.775Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/searchFilter.242f616094aae00a47f770fa23cc844e.svg";
export { ForwardRef as ReactComponent };